import { apiFetch } from './apiClient';



export const listarAtendimentos = () => apiFetch('/atendimentos');
export const criarAtendimento   = (dados) => apiFetch('/atendimentos', { method: 'POST', body: JSON.stringify(dados) });
export const atualizarAtendimento = (id, dados) => apiFetch(`/atendimentos/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const moverAtendimento   = (id, dados) => apiFetch(`/atendimentos/${id}/mover`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirAtendimento = (id) => apiFetch(`/atendimentos/${id}`, { method: 'DELETE' });

/* ── Etapas internas do atendimento (checklist do card) ── */
export const listarEtapasDoAtendimento = (id) => apiFetch(`/atendimentos/${id}/etapas`);
export const adicionarEtapas = (id, itens) => apiFetch(`/atendimentos/${id}/etapas`, { method: 'POST', body: JSON.stringify({ itens }) });
export const alternarEtapa = (etapaId, concluida) => apiFetch(`/atendimentos/etapas/${etapaId}`, { method: 'PATCH', body: JSON.stringify({ concluida }) });
export const editarTextoEtapa = (etapaId, texto) => apiFetch(`/atendimentos/etapas/${etapaId}`, { method: 'PATCH', body: JSON.stringify({ texto }) });
export const excluirEtapa = (etapaId) => apiFetch(`/atendimentos/etapas/${etapaId}`, { method: 'DELETE' });
